var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-modal',{attrs:{"title":_vm.title,"width":1200,"visible":_vm.visible,"footer":null,"destroyOnClose":true,"centered":true,"bodyStyle":{
    overflowY: 'hidden',
    padding: '0px',
    height: 'calc(100vh - 67px) !important',
    maxHeight: '880px',
  }},on:{"cancel":_vm.handleCancel}},[_c('a-spin',{staticClass:"a-spin-modeler",attrs:{"spinning":_vm.loading}},[_c('iframe',{staticStyle:{"border":"none","border-bottom-left-radius":"5px","border-bottom-right-radius":"5px"},attrs:{"width":"100%","height":"100%","src":_vm.src}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }